import React, { useEffect, useState } from 'react';
import '../../App.css';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import { BookModel } from '../../interfaces/book.interface';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { fetchAllBooks } from './services/BooksListService';
import BookCardItem from './components/BookItemDetails';

function BookList() {
  const user = useSelector((state: RootState) => state.user.user);
  const [books, setBooks] = useState<BookModel[]>([]);

  const fetchBooks = async () => {
    if (user && user.email) {
      try {
        const booksData = await fetchAllBooks(user.email);
        setBooks(booksData);
      } catch (error) {
        setBooks([]);
      }
    } else {
      setBooks([]);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, [user]);

  const [rotations, setRotations] = useState<Record<string, { rotateX: number; rotateY: number }>>({});

  const handleMouseMove = (bookId: string, e: any) => {

    const { width, height, top, left } = e.target.getBoundingClientRect();
    const mouseX = e.clientX - left; // Mouse X position within the element
    const mouseY = e.clientY - top; // Mouse Y position within the element

    // Calculate rotation:
    // - For X-axis, it should depend on the Y position of the mouse (mouseY)
    // - For Y-axis, it should depend on the X position of the mouse (mouseX)
    const rotateX = ((height / 2 - mouseY) / height) * 30; // Adjust the factor (30) for rotation intensity
    const rotateY = ((mouseX - width / 2) / width) * 30;

    setRotations((prev) => ({ ...prev, [bookId]: { rotateX, rotateY } }));
  };

  const handleMouseLeave = (bookId: string) => {
    setRotations((prev) => ({ ...prev, [bookId]: { rotateX: 0, rotateY: 0 } }));
  };

  return (
    <div className="App">
      <NavigationBar />

      <div className="bg-storytan p-4 mx-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-screen">
          <h2 className="text-left text-4xl mb-4 font-bold text-storyblue">Dashboard</h2>
          <div className="book-list grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-y-8 gap-x-8">
            {books?.map((book) => {
              if (!book.title) return null;

              // Use imageURLwebp if available, otherwise fall back to imageURL
              const imageUrl =
                book?.pages?.page4?.imageURLwebp || book?.pages?.page4?.imageURL || '/pattern.png';
              const rotation = book?.id ? rotations[book.id] || { rotateX: 0, rotateY: 0 } : { rotateX: 0, rotateY: 0 };


              return (
                <BookCardItem
                  key={book.id}
                  book={book}
                  imageUrl={imageUrl}
                  rotation={rotation}
                  handleMouseMove={handleMouseMove}
                  handleMouseLeave={handleMouseLeave}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookList;
